import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Camera Move-Around";

const callCameraMoveAround = async (
	messageId: string,
	jwt: string,
	angle: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		processImage: async ({ imageBase64, executionContext }) => {
			const data = {
				tool_document_id,
				inputs: {
					$img: imageBase64,
					$angle: angle,
				},
				jwt,
			};
			return fetchCameraMoveAround(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchCameraMoveAround(
	params: {
		tool_document_id: string;
		inputs: {
			$img: string;
			$angle: string;
		};
		jwt: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenCameraMoveAroundMessage() {
	useListenFromRenderer([
		{
			key: "cameraMoveAround",
			onMessage: async (message) => {
				const success = await callCameraMoveAround(
					message.id,
					message.values.jwt,
					message.values.angle,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
